import { InitDecimalMarker } from "./InitDecimalMarker";
import { InitThousandSeparator } from "./InitThousandSeparator";
import { Globals } from "../CoreApp/Globals";
import { QStringMgr } from "../CoreApp/QStringMgr";
import { QAccountInfo } from "../CoreApp/QAccountInfo";
import { QApp } from "../CoreApp/QApp";
import { QXWSMgr } from "../CoreApp/QXWSMgr";
import { enumPanelColors, enumPanelDarkColors } from "../constants";
import { QRFCMgr } from "../CoreApp/QRFCMgr.js";
import { QUIConfig } from "../CoreApp/QUIConfig.js";
import { QPublishSettings } from "../CoreApp/QPublishSettings.js";
import { QSvrChartMgr } from "../CoreApp/QSvrChartMgr.js";
import { QTimerMgr } from "../CoreApp/QTimerMgr.js";
import { IsTouchInput } from "./IsTouchInput";
import { SourceBrowser } from "./SourceBrowser";

export function GlobalInit(cb) {
  Globals._app = new QApp();
  Globals._wsMgr = new QXWSMgr();
  Globals._accountInfo = new QAccountInfo();
  Globals._stringMgr = new QStringMgr();
  Globals._stringMgr.ResetStringMgr();

  Globals._rfcMgr = new QRFCMgr();
  Globals._dpr = window.devicePixelRatio || 1;
  Globals._uiConfig = new QUIConfig();
  Globals._uiConfig.fWSMgr = Globals._wsMgr;
  Globals._pubSettings = new QPublishSettings();
  Globals._svrChartMgr = new QSvrChartMgr();
  Globals._timerMgr = new QTimerMgr();
  Globals._scaleFactor = 0.75;
  Globals._themeMode =
    localStorage.thememode === "darkmode" ? enumPanelDarkColors : enumPanelColors;
  Globals._mobileDevice = IsTouchInput();
  SourceBrowser();
  InitDecimalMarker();
  InitThousandSeparator();

  cb();
}
